import { useCallback } from 'react';
import { TouchableOpacity } from 'react-native';
import { OverflowMenuProps } from '@ui-kitten/components';
import { useTranslation } from 'react-i18next';

import { OverflowMenu, MenuItem } from '@pletly/ui';
import { useToggle } from '%hooks';
import { HamburgerIcon } from '%components/icons/Hamburger';

export const OptionsMenu = ({ onEdit, onDelete, onOptionsPress, ...menuProps }: Props) => {
	const [isMenuOpened, toggleMenu] = useToggle();
	const { t } = useTranslation();

	const handleMenuItemPress = useCallback(
		(pressHandler?: PressHandlerType) => () => {
			toggleMenu();
			pressHandler?.();
		},
		[toggleMenu],
	);

	return (
		<OverflowMenu
			anchor={() => (
				<TouchableOpacity
					onPress={() => {
						onOptionsPress?.();
						toggleMenu();
					}}
				>
					<HamburgerIcon />
				</TouchableOpacity>
			)}
			visible={isMenuOpened}
			onBackdropPress={toggleMenu}
			{...menuProps}
		>
			<>
				<MenuItem title={t('common.edit')} onPress={handleMenuItemPress(onEdit)} />
				<MenuItem
					title={t('common.delete')}
					status="danger"
					onPress={handleMenuItemPress(onDelete)}
				/>
			</>
		</OverflowMenu>
	);
};

type PressHandlerType = () => unknown;

type Props = Omit<OverflowMenuProps, 'anchor'> & {
	onEdit?: PressHandlerType;
	onDelete?: PressHandlerType;
	onOptionsPress?: PressHandlerType;
};
